const PSLinearScalePosItem = cc.Class({
    name: 'PSLinearScalePosItem',
    properties: {
        aspectRatio: 0,
        
        x: 0,
        y: 0,
        scaleX: 0,
        scaleY: 0,
    }
})

cc.Class({
    extends: cc.Component,

    properties: {
        target: cc.Node,
        handlePosition: false,
        handleScale: false,
        isAbsolutePosition: {
            default: false,
            visible: function () {
                return this.handlePosition;
            }
        },
        isAbsoluteScale: {
            default: false,
            visible: function () {
                return this.handleScale;
            }
        },
        linearDataArray: [PSLinearScalePosItem],
    },

    onLoad () {
        this.resizeManager = cc.find('ResizeManager').getComponent('ResizeManager');
        
        if (!this.resizeManager) {
            this.node.removeComponent('PSLinearScalePosChanger');
            cc.warn('PSLinearScalePosChanger: no resize manager found');
        }

        if (!this.target) {
            this.target = this.node;
        }

        this.originX = this.target.x;
        this.originY = this.target.y;
        this.originScaleX = this.target.scaleX;
        this.originScaleY = this.target.scaleY;

        this.linearDataArray.sort(function (a, b) {
            return a.aspectRatio - b.aspectRatio;
        });

        
        if (this.linearDataArray.length > 1) {
            this.resizeManager.appendNode(this);
        } else {
            this.node.removeComponent('PSLinearScalePosChanger');
        }
 
    },

    onDestroy() {
        this.resizeManager.removeNode(this);
    },

    onViewResize (_screenRatio, aspectRatio) {
        let index = -1;
        
        for(let i = 0; i < this.linearDataArray.length; i++) {
            const data = this.linearDataArray[i];

            if (aspectRatio < data.aspectRatio) {
                index = i;
                break;
            }
        }
        
        this._position(index, aspectRatio);
    },

    _position (index, aspectRatio) {
        if (index < 1) {
            this.target.x = this.originX;
            this.target.y = this.originY;
            this.target.scaleX = this.originScaleX;
            this.target.scaleY = this.originScaleY;
            return;
        }

        const data = this.linearDataArray[index];
        const prevData = this.linearDataArray[index - 1];

        const initialX = this.isAbsolutePosition ? 0 : this.originX;
        const initialY = this.isAbsolutePosition ? 0 : this.originY;
        const initialScaleX = this.isAbsoluteScale ? 1 : this.originScaleX;
        const initialScaleY = this.isAbsoluteScale ? 1 : this.originScaleY;

        const diff = (data.aspectRatio - prevData.aspectRatio);
        const coef = (aspectRatio - prevData.aspectRatio) / diff;
        
        if (this.handlePosition) {
            this.target.x = initialX + prevData.x + coef * (data.x - prevData.x);
            this.target.y = initialY + prevData.y + coef * (data.y - prevData.y);
        }

        if (this.handleScale) {
            this.target.scaleX = (prevData.scaleX + coef * (data.scaleX - prevData.scaleX)) * initialScaleX;
            this.target.scaleY = (prevData.scaleY + coef * (data.scaleY - prevData.scaleY)) * initialScaleY;
        }
    }
});
